// src/components/DateDisplay/DateDisplay.tsx
import React, { useState, useEffect } from 'react';
import uq from '@umalqura/core';
import './DateDisplay.css';

const DateDisplay: React.FC = () => {
  const [currentDate, setCurrentDate] = useState(new Date());
  const [hijriDate, setHijriDate] = useState<any>(null);

  useEffect(() => {
    const timer = setInterval(() => {
      const now = new Date();
      setCurrentDate(now);
      const hijri = uq(now);
      setHijriDate(hijri);
    }, 1000);

    return () => clearInterval(timer);
  }, []);

  const gregorianMonths = [
    'Janvier', 'Février', 'Mars', 'Avril', 'Mai', 'Juin',
    'Juillet', 'Août', 'Septembre', 'Octobre', 'Novembre', 'Décembre'
  ];

  const hijriMonthsArabic = [
    'محرم', 'صفر', 'ربيع الأول', 'ربيع الثاني',
    'جمادى الأولى', 'جمادى الآخرة', 'رجب', 'شعبان',
    'رمضان', 'شوال', 'ذو القعدة', 'ذو الحجة'
  ];

  // Phonétique française des mois arabes
  const hijriMonthsPhonetic = [
    'Muharram', 'Safar', "Rabi' al-Awwal", "Rabi' ath-Thani",
    'Jumada al-Ula', 'Jumada ath-Thaniyah', 'Rajab', "Sha'ban",
    'Ramadan', 'Shawwal', 'Dhu al-Qi\'dah', 'Dhu al-Hijjah'
  ];

  const dayNamesFr = [
    'Dimanche', 'Lundi', 'Mardi', 'Mercredi', 'Jeudi', 'Vendredi', 'Samedi'
  ];

  const dayNamesAr = [
    'الأحد', 'الإثنين', 'الثلاثاء', 'الأربعاء', 'الخميس', 'الجمعة', 'السبت'
  ];

  const toArabicNumerals = (num: number): string => {
    const arabicNumerals = ['٠', '١', '٢', '٣', '٤', '٥', '٦', '٧', '٨', '٩'];
    return num.toString().split('').map(digit => arabicNumerals[parseInt(digit)]).join('');
  };

  if (!hijriDate) return null;

  const dayNameFr = dayNamesFr[currentDate.getDay()];
  const dayNameAr = dayNamesAr[currentDate.getDay()];

  return (
    <div className="date-display-hero">
      <div className="date-card">
        {/* Ligne des jours */}
        <div className="days-line">
          <span className="day-fr">{dayNameFr}</span>
          <span className="day-sep">•</span>
          <span className="day-ar">{dayNameAr}</span>
        </div>
        
        {/* Ligne des dates */}
        <div className="dates-line">
          <span className="greg-date">
            {currentDate.getDate()} {gregorianMonths[currentDate.getMonth()]} {currentDate.getFullYear()}
          </span>
          <span className="date-divider">|</span>
          <span className="hijri-date-wrapper">
            <span className="hijri-date-arabic">
              {toArabicNumerals(hijriDate.hd)} {hijriMonthsArabic[hijriDate.hm - 1]} {toArabicNumerals(hijriDate.hy)} هـ
            </span>
            <span className="hijri-date-phonetic">
              {hijriDate.hd} {hijriMonthsPhonetic[hijriDate.hm - 1]} {hijriDate.hy} H
            </span>
          </span>
        </div>
      </div>
    </div>
  );
};

export default DateDisplay;